import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { GlobalVariables } from 'src/app/GlobalVariables';
import { CommonService } from 'src/app/Shared/common.service';

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.css']
})
export class AuditTrailComponent implements OnInit{
  
  IsLoadingResults:boolean = false;
  displayedColumns = ['fieldName','action', 'oldValue', 'newValue',  'createdOn', 'createdBy', ]; //4.Audit Trail Issues - InatxGTC Defect By shipra Mam // Changes done by Rehan
  dataSource!: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private commonService: CommonService, private _route: Router, private global: GlobalVariables) { }
  ngOnInit() {
    this.IsLoadingResults = true;
    this.commonService.getAuditTrails(this.global.auditTrailId, this.global.auditTrailClass)
      .subscribe(
        (stream: any) => {
          if (stream['RequestIsSuccess']) {
            this.IsLoadingResults = false;
            this.dataSource = new MatTableDataSource(stream['lstAuditTrail']);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          } else {
            this.IsLoadingResults = false;
            alert(stream['RequestMessage']);
            // this._route.navigate(['UnhandledException']);
          }
        },
        (error: any) => {
          this.IsLoadingResults = false;
          // Handle the error here, e.g. display an error message or navigate to an error page
        }
      );
    
  }

}
